<template>
  <div class="py-6 text-base">
    <div v-if="shouldShowDeliveryTimes" class="grid grid-cols-2 gap-y-3">
      <template v-if="deliveryTimeTextForHomeDyn">
        <div class="col-span-1 font-normal">
          <p class="truncate" :title="t['w.module.delivery_section.delivery_time.home']()">{{ t['w.module.delivery_section.delivery_time.home']() }}</p>
        </div>
        <div class="col-span-1 text-right font-medium">
          <p>{{ deliveryTimeTextForHomeDyn }}</p>
        </div>
      </template>

      <template v-if="deliveryTimeTextForParcelTerminalDyn">
        <div class="col-span-1 font-normal">
          <p class="truncate" :title="t['w.module.delivery_section.delivery_time.parcel_machine']()">{{ t['w.module.delivery_section.delivery_time.parcel_machine']() }}</p>
        </div>
        <div class="col-span-1 text-right font-medium">
          <p>{{ deliveryTimeTextForParcelTerminalDyn }}</p>
        </div>
      </template>

      <template v-if="deliveryTimeTextForSelfPickupDyn">
        <div class="col-span-1 font-normal">
          <p class="truncate" :title="t['w.module.delivery_section.delivery_time.self_delivery']()">{{ t['w.module.delivery_section.delivery_time.self_delivery']() }}</p>
        </div>
        <div class="col-span-1 text-right font-medium">
          <p>{{ deliveryTimeTextForSelfPickupDyn }}</p>
        </div>
      </template>
    </div>
    <div v-else class="grid grid-cols-2 gap-y-3">
      <div class="col-span-1 font-normal">
        <p class="truncate" :title="t['w.module.delivery_section.delivery_time']()">{{ t['w.module.delivery_section.delivery_time']() }}</p>
      </div>
      <div class="col-span-1 text-right font-medium">
        <p>{{ t['w.module.delivery_section.delivery_time.select_option']() }}</p>
      </div>
    </div>
    <div v-if="fitsParcelTerminal || shouldShowAskForMoreInfoHelper" class="mt-4">
      <div v-if="fitsParcelTerminal" class="flex items-center pt-2">
        <Icon name="parcel-24" class="mr-3 size-6" />
        <div>{{ t['w.module.delivery_section.parcel_machine']() }}</div>
      </div>

      <div v-if="shouldShowAskForMoreInfoHelper" class="flex items-center pt-2">
        <Icon name="headphones" class="mr-3 size-6" />
        <div class="delivery-section-transport" v-html="t['w.module.delivery_section.ask_more']({ toode: productCode })" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Icon from '~/components/icon/Icon.vue'
import * as t from '~/messages'

const props = defineProps({
  shouldShowDeliveryTimes: { type: Boolean, default: null },
  deliveryTimeTextForHome: { type: String, default: null },
  deliveryTimeTextForSelfPickup: { type: String, default: null },
  deliveryTimeTextForParcelTerminal: { type: String, default: null },
  shouldShowAskForMoreInfoHelper: { type: Boolean, default: false },
  fitsParcelTerminal: { type: Boolean, default: false },
  productCode: { type: String, default: null },
  selectedOptions: { type: Object, default: null },
})

const selectedOptionType3 = computed(() => {
  // assume type 3
  if (!props.selectedOptions) {
    return null
  }

  return Object.values(props.selectedOptions)[0]
})

const doesOptionHaveItsOwnDeliveryTime = computed(
  () =>
    selectedOptionType3.value &&
    (selectedOptionType3.value.deliveryTimeTextForHome || selectedOptionType3.value.deliveryTimeTextForSelfPickup || selectedOptionType3.value.deliveryTimeTextForParcelTerminal)
)

const deliveryTimeTextForHomeDyn = computed(() => {
  if (doesOptionHaveItsOwnDeliveryTime.value) {
    return selectedOptionType3.value.deliveryTimeTextForHome
  }

  return props.deliveryTimeTextForHome
})

const deliveryTimeTextForSelfPickupDyn = computed(() => {
  if (doesOptionHaveItsOwnDeliveryTime.value) {
    return selectedOptionType3.value.deliveryTimeTextForSelfPickup
  }

  return props.deliveryTimeTextForSelfPickup
})

const deliveryTimeTextForParcelTerminalDyn = computed(() => {
  if (doesOptionHaveItsOwnDeliveryTime.value) {
    return selectedOptionType3.value.deliveryTimeTextForParcelTerminal
  }

  return props.deliveryTimeTextForParcelTerminal
})
</script>

<style lang="scss" scoped>
.delivery-section-transport {
  a {
    color: theme('colors.text.strong.DEFAULT');
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
}
</style>
